import Cookies from 'js-cookie';
import $ from 'jquery';

let popupInit = () => {

  let showPopup = () => {
    setTimeout( () => {
      $( 'body' ).addClass( 'no-scroll' );
      $( '.popup-bg' ).addClass( 'active' );
    }, 1200 ) 
  }
  
  let hidePopup = ( elem, expiry ) => {
    $( '.popup-bg' ).removeClass( 'active' );
    $( 'body' ).removeClass( 'no-scroll' )
    let data = $( elem ).data( 'popup' );
    Cookies.set( data, 'true', {expires: expiry });
  }
  
  let popup = $( '.popup-bg' ).children().data( 'popup' )

  if ( ! ( Cookies.get( popup ) == 'true' ) ) { 
    showPopup();
  } 

  $( '.popup-bg .close, .popup-bg-close' ).on( 'click', function() {
    hidePopup( this, 1 );
  }) 

  $( '.js-register' ).on( 'click', function() {
    hidePopup( this, 14 );
  })

}

$( () => {
  if( $( '.popup-bg' ).length ) {
    popupInit();
  }
})